import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'
const base = 'orders'

AdminRouter.addRoutes([
  {
    name: `${base}`,
    path: `/${base}`,
    component: () => import('./Index.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `${base}.create`,
    path: `/${base}/create`,
    component: () => import('./Create.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `${base}.edit`,
    path: `/${base}/:id`,
    component: () => import('./Edit.vue'),
    meta: {
      auth: true,
    },
  },
])

AdminSidebar.pushItem({
  id: `${base}`,
  order: 30,
  header: $vm => $vm.$t(`general.menu_main`),
  text($vm) {
    return $vm.$t(`${base}.title`)
  },
  route: {
    name: `${base}`,
  },
  icon: 'icon-coins',
  permission: 'orders.index',
})

messageGroups.push(base)
